import getAll from 'utils/getAll'
import { apiUrls } from 'consts'

const getRows = async () => {
  const data = await getAll(apiUrls.auditLog)

  return data.map((row: any) => ({
    ...row,
    user_email: row.user?.email ?? '',
  }))
}

export default getRows
